var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBotswana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.755561 11.1304C0.265436 12.666 -1.45381e-06 14.3018 6.10462e-05 16C-1.45381e-06 17.6981 0.265436 19.3339 0.755624 20.8696L16.0001 21.5653L31.2444 20.8696C31.7345 19.3339 32 17.698 32 16.0001C32 14.3019 31.7346 12.666 31.2444 11.1304L16 10.4348L0.755561 11.1304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 15.0508 31.9169 14.121 31.7583 13.2173H0.24175C0.083125 14.121 0 15.0507 0 15.9999C0 16.9492 0.0831875 17.8788 0.24175 18.7825H31.7583C31.9168 17.8787 32 16.9491 32 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 31.9999C23.1389 31.9999 29.1845 27.3247 31.2447 20.8694H0.75592C2.81623 27.3246 8.86192 31.9998 16.0004 31.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 2.50646e-09C8.86192 2.50646e-09 2.8163 4.67519 0.755859 11.1303L31.2446 11.1304C29.1844 4.67519 23.1387 -0.000124998 16.0004 2.50646e-09Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBotswana);
export default __webpack_public_path__ + "static/media/flag_botswana.3bf7497978f9b3c1a590b9c8d5ab4176.svg";
export { ForwardRef as ReactComponent };